module.exports = __webpack_public_path__ + "57591e3456f2878e1b9b4a0036c6c578.svg";